<template>
  <div class="page__section">
    <div class="container">
      <div class="advantages advantages_hidden-additions">
        <ul class="advantages__list">

          <li class="advantages__item">
            <h4 class="advantages__name">Официальный<br>дилер</h4>
            <div class="advantages__image">
              <dealer/>
            </div>
            <div class="advantages__addition">Официаль&shy;ные прямые поставки большого числа серти&shy;фицирован&shy;ного оборудо&shy;вания&nbsp;— гарантия качества и&nbsp;низкой цены.</div>
          </li>

          <li class="advantages__item">
            <h4 class="advantages__name">Подробные<br>консультации</h4>
            <div class="advantages__image">
              <consultation/>
            </div>
            <div class="advantages__addition">Помогаем подбирать оборудо&shy;вание и&nbsp;расходные материалы. При&nbsp;необходи&shy;мости подключаем инженеров.</div>
          </li>

          <li class="advantages__item">
            <h4 class="advantages__name">Склад<br>оборудования</h4>
            <div class="advantages__image">
              <storage_1/>
            </div>
            <div class="advantages__addition">Тысячи наименова&shy;ний инженер&shy;ного оборудо&shy;вания в&nbsp;наличии, в&nbsp;Краснодаре. Регуляр&shy;ные поставки.</div>
          </li>

          <li class="advantages__item">
            <h4 class="advantages__name advantages__name_with-link">
              Склад<br>запчастей
            </h4>
            <div class="advantages__image">
              <storage_2/>
            </div>
            <div class="advantages__addition">Тысячи наименова&shy;ний оригиналь&shy;ных запасных частей и&nbsp;комплекту&shy;ющих в&nbsp;наличии, в&nbsp;Краснодаре&nbsp;— ждать не&nbsp;надо.</div>
          </li>

          <li class="advantages__item">
            <h4 class="advantages__name advantages__name_with-link">
              Доставка<br>по&nbsp;адресу
            </h4>
            <div class="advantages__image">
              <delivery/>
            </div>
            <div class="advantages__addition">Краснодарский и&nbsp;Ставропольский край, Ростовская область, Крым и&nbsp;Адыгея. Собственный автопарк.</div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import consultation from "./advantages_svg/consultation";
import dealer from "./advantages_svg/dealer";
import delivery from "./advantages_svg/delivery";
import storage_1 from "./advantages_svg/storage_1";
import storage_2 from "./advantages_svg/storage_2";
export default {
  name: "ProductAdvantages",
  components: {
    consultation,
    delivery,
    dealer,
    storage_1,
    storage_2,
  }
}
</script>

<style scoped>
</style>